import { t } from 'ttag'

export const INITIAL_VISIBLE_FACETS = 4

export const getAreaDetailSections = () => [
  {
    contributorsKey: 'increase_contributors',
    hint: t`The candidate scores high:`,
    sectionTone: 'Increase',
    title: t`Facets that contribute positively`,
  },
  {
    contributorsKey: 'moderate_contributors',
    hint: null,
    sectionTone: 'Moderate',
    title: t`Facets that contribute moderately`,
  },
  {
    contributorsKey: 'decrease_contributors',
    hint: t`The candidate scores low/high:`,
    sectionTone: 'Decrease',
    title: t`Facets that contribute negatively`,
  },
]
